import * as R from 'ramda'
import {
    FETCH_COMMENTS_TIME_SUCCESS,
} from '../actionTypes'

const InitialState = {};

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case FETCH_COMMENTS_TIME_SUCCESS:
            return {...payload}

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/commentsTime.js